
import { Permission } from "@/api/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class RolePermissionsList extends Vue {
  @Prop({ required: true }) permissions!: Array<Permission>;
  @Prop({ default: () => [] }) value!: Array<number>;

  headers = [
    { text: "", value: "checkbox", sortable: false, width: 56 },
    { text: "Name", value: "display_name" },
    { text: "Code", value: "name" },
    { text: "Description", value: "description", sortable: false }
  ];

  get items(): Array<Permission> {
    return this.permissions.map((item: Permission) => ({
      ...item,
      group: item.group || "OTHER"
    }));
  }

  toggleItem(id: number): void {
    const model = this.value.includes(id)
      ? this.value.filter((item: number) => item !== id)
      : [...this.value, id];
    this.$emit("input", model);
  }
}
